// the player is quite big, so load it delayed
import "@lottiefiles/lottie-player";
import ScrollObserver from "./helpers/ScrollObserver";

// start only when near viewport
document.querySelectorAll('lottie-player.lottie-player--autoplay-near-viewport').forEach(el => {
    ScrollObserver.onMostlyVisible(el, (entry) => {
        el.play();
    });
});
